import React from 'react';
import { apiGetPhoto, apiIsLoggedIn } from '../../../api/api';
import ReunionPhoto from './ReunionPhoto';

class ReunionPhotosTableTab extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            rowOne: null,
            rowTwo: null,
            lastList: props.photoList,
        }
    }

    componentDidMount() {
        this.updatePhotos();
    }

    async componentDidUpdate() {
        if (this.shouldUpdatePhotos(this.props.photoList, this.state.lastList)) {
            this.updatePhotos();
        }
    }

    shouldUpdatePhotos(propsList, stateList) {
        if (propsList.length != stateList.length) {
            return true;
        }

        for (var i = 0; i < propsList.length; i++) {
            if (propsList[i] !== stateList[i]) {
                return true;
            }
        }

        return false;
    }

    updatePhotos() {
        const middle = Math.ceil(this.props.photoList.length / 2);

        const uriFirstHalf = this.props.photoList.length > 5 ? this.props.photoList.slice(0, middle) : this.props.photoList;
        const uriSecondHalf = this.props.photoList.length > 5 ? this.props.photoList.slice(middle) : null;

        this.setState({
            ...this.state,
            rowOne: uriFirstHalf.map((photoUri) => {
                        return (<ReunionPhoto photoUri={photoUri} key={photoUri}/>);
                    }),
            rowTwo: uriSecondHalf ? uriSecondHalf.map((photoUri) => {
                        return (<ReunionPhoto photoUri={photoUri} key={photoUri}/>);
                    }) : null,
            lastList: this.props.photoList,
        });
    }

    render() {
        const rowStyle = {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-end"
        }

        return (
            <div>
                <div style={rowStyle}>
                    {this.state.rowOne ? this.state.rowOne : <p>Loading...</p>}
                </div>
                <div style={rowStyle}>
                    {this.state.rowTwo ? this.state.rowTwo : null}
                </div>
            </div>
        )
    }
}

export default ReunionPhotosTableTab;
